module.exports = __webpack_public_path__ + "static/media/Respiratory_System_LowNormalsMap.855a41aa.jpg";